import { useEffect, useState } from "react";
import { CalendarClock } from "lucide-react";
import tr from "@/i18n/tr";
import api from "@/lib/api";

const fmt = (iso) => { try { return iso ? new Date(iso).toLocaleDateString("tr-TR", { day: "2-digit", month: "short", year: "numeric" }) : ""; } catch { return ""; } };

export default function UpcomingDeliveries() {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        (async () => {
            try {
                const now = new Date();
                const in14 = new Date(now.getTime() + 14 * 24 * 3600 * 1000).toISOString();
                const { data } = await api.get("/content-calendar", { params: { start: now.toISOString(), end: in14, page_size: 5 } });
                setItems(data.items || []);
            } catch { setItems([]); }
            finally { setLoading(false); }
        })();
    }, []);
    return (
        <div className="card-elevated p-5">
            <div className="flex items-start justify-between mb-4">
                <div>
                    <div className="text-[13px] font-semibold text-foreground">{tr.dashboard.stats.upcomingDeliveries}</div>
                    <div className="text-[11.5px] text-muted-foreground mt-0.5">Yaklaşan 14 gün</div>
                </div>
            </div>
            {loading ? (
                <div className="text-[12px] text-muted-foreground py-6 text-center">Yükleniyor…</div>
            ) : items.length === 0 ? (
                <div className="text-center py-8 text-muted-foreground">
                    <CalendarClock className="h-8 w-8 mx-auto mb-2 opacity-30" />
                    <div className="text-[12.5px]">Yaklaşan teslim yok.</div>
                </div>
            ) : (
                <ul className="space-y-3">
                    {items.map((it) => (
                        <li key={it.id} className="group flex items-center gap-3 rounded-xl px-2 py-2 hover:bg-muted/60 transition-colors">
                            <span className="h-8 w-1 rounded-full bg-[hsl(var(--brand))]" />
                            <div className="min-w-0 flex-1">
                                <div className="text-[12.5px] font-semibold truncate">{it.title}</div>
                                <div className="text-[11.5px] text-muted-foreground truncate">{it.customer_name || "—"}</div>
                            </div>
                            <div className="text-[11.5px] text-muted-foreground shrink-0">{fmt(it.scheduled_at)}</div>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}
